import React, {useEffect, useState} from 'react';
import api from "../../api";
import {Button, Card, Col, message, Modal, Row, Tag} from "antd";
import {DEFAULT_GUTTER} from "../../constants";
import CdnImage from "../CdnImage";
import {ArrowRightOutlined, MinusOutlined, PlusOutlined, ShoppingCartOutlined} from "@ant-design/icons";
import {printPrice} from "../../helpers";
import ReadMore from "../ReadMore";
import dayjs from "dayjs";
import {useTranslations} from "../../lang";

export default function OfferList({company}) {

    const cartFromStorage = localStorage.getItem('cart')
    const [cart, setCart] = useState(cartFromStorage ? JSON.parse(cartFromStorage) : {});

    const [offers, setOffers] = useState([]);
    const [addedToCartModalOpen, setAddedToCartModalOpen] = useState(false);
    const {translate} = useTranslations()
    const [loadingOffers, setLoadingOffers] = useState(false);

    useEffect(() => {
        if (company && company.id) {
            setLoadingOffers(true);
            api.getCompanyOffers(company.id).then(setOffers).finally(() => {
                setLoadingOffers(false)
            })
        }
    }, [company]);


    useEffect(() => {
        localStorage.setItem('cart', JSON.stringify(cart))
    }, [cart]);


    const addToCart = (offer, showModal = false) => {
        if (offer.stock === 0) {
            message.error(translate('Dit product is uitverkocht.'));
            return;
        }
        if (!cart[offer.id]) {
            cart[offer.id] = {
                ...offer,
                quantity: 1,
            }
        } else {
            const newQuantity = cart[offer.id].quantity + 1;
            if (newQuantity > offer.stock) {
                message.error(translate('Sorry, er is niet meer in voorraad Dit is het maximale wat je kan bestellen.'));
                return;
            }
            cart[offer.id].quantity += 1
        }
        if (showModal) {
            setAddedToCartModalOpen(true)
        }
        setCart({...cart})
    }

    const removeFromCart = (offer) => {
        if (!cart[offer.id]) {
            return
        }

        if (cart[offer.id].quantity === 1) {
            delete cart[offer.id]
        } else {
            cart[offer.id].quantity -= 1
        }

        setCart({...cart})
    }

    const cartList = Object.values(cart);
    const totalQuantity = cartList.reduce((total, offer) => total + offer.quantity, 0);

    return (

        <>
        {totalQuantity > 0 && (
            <Button type={"primary"} size={"large"}
                    onClick={() => {
                        setAddedToCartModalOpen(true)
                    }}
                    style={{position: 'fixed', bottom: 0, right: 0, margin: 28, zIndex: 10000}}>
                <ShoppingCartOutlined/> Winkelwagen <Tag>{totalQuantity}</Tag>
            </Button>
        )}
        <Modal open={addedToCartModalOpen && cartList.length > 0} footer={null}
                   onCancel={() => setAddedToCartModalOpen(false)}>
                <h2>Het product is toegevoegd aan je winkelmand!</h2>

                {cartList.map((offer) => (
                    <Row gutter={DEFAULT_GUTTER} key={`cart_` + offer.id} style={{borderBottom: 'solid 1px silver'}}
                         className={"pad-1"}>
                        <Col span={4}>
                            <CdnImage src={offer.image} width={50} height={50}/>
                        </Col>
                        <Col span={20}>
                            <p>{offer.title}</p>
                            <Button className={"mar-r-1"} type={"primary"} size={"small"}
                                    onClick={() => removeFromCart(offer)}>
                                <MinusOutlined/>
                            </Button>
                            <span className={"mar-r-1"}>{cart[offer.id].quantity}x {offer.unit}</span>
                            <Button type={"primary"} size={"small"}
                                    onClick={() => addToCart(offer)}>
                                <PlusOutlined/>
                            </Button>
                        </Col>
                    </Row>
                ))}

                <Row justify={"center"} className={"mar-t-1"}>

                    <Col xs={24} md={0}>
                        <Button type={"primary"} href={`/${company.slug}/cart`} size={"large"}>Verder naar
                            bestellen <ArrowRightOutlined/></Button>
                    </Col>

                    <Col xs={24} md={12}>
                        <Button type={"link"} size={"large"} onClick={() => {
                            setAddedToCartModalOpen(false);
                        }}>meer bestellen</Button>
                    </Col>
                    <Col xs={0} md={12} className={"text-right"}>
                        <Button type={"primary"} href={`/${company.slug}/cart`} size={"large"}>Verder naar
                            bestellen <ArrowRightOutlined/></Button>
                    </Col>

                </Row>
            </Modal>
            {totalQuantity > 0 && (
                <Button type={"primary"} size={"large"}
                        onClick={() => {
                            setAddedToCartModalOpen(true)
                        }}
                        style={{position: 'fixed', bottom: 0, right: 0, margin: 28, zIndex: 10000}}>
                    <ShoppingCartOutlined/> Winkelwagen <Tag>{totalQuantity}</Tag>
                </Button>
            )}

            {loadingOffers && (
                <Row justify={"center"} className={"mar-t-2"}>
                    <Col>
                        <h2>Bezig met laden...</h2>
                    </Col>
                </Row>
            )}

            {!loadingOffers && offers.length === 0 && (
                <Row justify={"center"} className={"mar-t-2"}>
                    <Col>
                        <h2>Er zijn geen aanbiedingen gevonden.</h2>
                    </Col>
                </Row>
            )}

            {!loadingOffers && offers.length > 0 && (
                <Row className={"mar-b-1"} gutter={DEFAULT_GUTTER}>
                    {offers.map(offer => (
                        <Col md={6} xs={24} key={`offer${offer.id}`}>
                            <Card style={{height: '100%'}}>
                                <h2>{offer.title}</h2>
                                <div className={"mar-b-1"}>
                                    <CdnImage src={offer.image} width={1024} height={768} style={{
                                        borderRadius: '10px',
                                        maxWidth: '100%',
                                        maxHeight: '2',
                                        width: '100%',
                                        height: '250px',
                                        objectFit: 'cover',
                                        objectPosition: 'center'
                                    }}/>
                                </div>
                                {offer.price > 0 && (
                                    <h3>{printPrice(offer.price)}{
                                        offer.unit && <span> per {offer.unit}</span>
                                    }</h3>
                                )}
                                {offer.price === 0 && (
                                    <h3>Gratis!</h3>
                                )}

                                <ReadMore text={offer.description}/>

                                {(dayjs(offer.start_at).isAfter(dayjs())) && (
                                    <p>Beschikbaar <b>{dayjs(offer.start_at).fromNow()}</b></p>
                                )}

                                {offer.stock > 0 && (
                                    <Row gutter={DEFAULT_GUTTER} className={"mar-t-1"} align={"bottom"}>
                                        <Col span={24} className={"text-right"}>
                                            {(dayjs(offer.start_at).isBefore(dayjs())) && (
                                                <Button type={"primary"} size={"large"}
                                                        onClick={() => addToCart(offer, true)}>
                                                    <ShoppingCartOutlined/> In winkelwagen
                                                </Button>
                                            )}
                                        </Col>
                                    </Row>
                                )}
                                {offer.stock === 0 && (
                                    <p>{translate('Dit product is uitverkocht.')}</p>
                                )}
                            </Card>
                        </Col>
                    ))}
            </Row>
            )}
        </>
    )

}